import React from "react";
import { AirplaneTilt, Bed, Car, MapPin, Package, Taxi } from "@phosphor-icons/react";

const ICONS = { flights: AirplaneTilt, stays: Bed, flightHotel: Package, cars: Car, attractions: MapPin, taxis: Taxi };

// Accent boundaries belong to the translation, not to a word-count heuristic.
function Heading({ title, accent }) {
  const at = accent ? title.indexOf(accent) : -1;
  if (at < 0) return title;
  return <>{title.slice(0, at)}<em>{accent}</em>{title.slice(at + accent.length)}</>;
}

export default function ServiceIntro({ service, label, title, description, accent, tone = "light", titleTestId }) {
  const Icon = ICONS[service];
  return (
    <div className={`service-intro service-intro--${tone}`} data-service={service}>
      {/* Only this presentation remounts on a tab change. Forms keep their own identity. */}
      <div className="service-intro__copy" key={service}>
        <div className="service-intro__label">
          {Icon && <Icon size={18} weight="bold" aria-hidden="true" />}
          {label}
        </div>
        <h1 className="service-intro__title font-display" data-testid={titleTestId}>
          <Heading title={title} accent={accent} />
        </h1>
        <p className="service-intro__description">{description}</p>
      </div>
      {Icon && (
        <div className="service-intro__mark" aria-hidden="true" key={`mark-${service}`}>
          <span className="service-intro__orbit" />
          <span className="service-intro__symbol"><Icon size={64} weight="light" aria-hidden="true" /></span>
        </div>
      )}
    </div>
  );
}
